import {
  EditCaseActionTypes,
  EDIT_CASE_FAIL,
  EDIT_CASE_LOADING,
  EDIT_CASE_SUCCESS,
  EditCaseState,
  EDIT_CASE_API_MSG,
  EDIT_CASE_API_RES,
} from "./ActionTypes";
import { EditCaseResponse } from "./Model";

const initialStateEditPosts: EditCaseState = {
  loading: false,
  editCaseResponse: {} as EditCaseResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const editCaseReducer = (
  state = initialStateEditPosts,
  action: EditCaseActionTypes
): EditCaseState => {
  switch (action.type) {
    case EDIT_CASE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case EDIT_CASE_SUCCESS:
      return {
        ...state,
        editCaseResponse: action.payload,
        successMsg: action.successMsg,
      };
    case EDIT_CASE_FAIL:
      return {
        ...state,
        editCaseResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case EDIT_CASE_API_MSG:
      return {
        ...state,
        editCaseResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case EDIT_CASE_API_RES:
      return {
        ...state,
        editCaseResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
